import List from './List';
import Edit from './Edit';
import Detail from './Detail';

export {
    List,
    Edit,
    Detail,
};
